import React from "react";

/* ---------- Icons ---------- */
export function MinusIcon(props) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" {...props}>
      <path d="M5 12h14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}
export function PlusIcon(props) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" {...props}>
      <path d="M12 5v14M5 12h14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}
export function HamburgerIcon(props) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" {...props}>
      <path d="M3 6h18M3 12h18M3 18h18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

/* ---------- Buttons/Inputs ---------- */
export function StatIconButton({ onClick, label, children }) {
  return (
    <button
      type="button"
      aria-label={label}
      title={label}
      onClick={onClick}
      className="icon-btn"
    >
      {children}
    </button>
  );
}

export function StatButton({ onClick, children, title, variant = "default" }) {
  return (
    <button
      type="button"
      title={title}
      onClick={onClick}
      className={`btn ${variant === "primary" ? "btn-primary" : ""}`}
    >
      {children}
    </button>
  );
}

export function TextInput({ label, type = "text", value, onChange, placeholder, inputRef, className, disabled }) {
  const id = label.replaceAll(" ", "-").toLowerCase();
  return (
    <label className="field">
      <span className="field-label">{label}</span>
      <input
        ref={inputRef}
        id={id}
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        disabled={disabled}
        className={`input ${className || ""}`}
      />
    </label>
  );
}

// Export SyncStatusIndicator from its own file
export { default as SyncStatusIndicator } from './ui/SyncStatusIndicator';
